<template>
	<div style="width: 100%; height: 100vh; background-color: #f1452f;">
		<div class="QRcode">
			<!--顶部搜索框 -->
			<div class="nav" style="border: none;">
				<van-icon name="arrow-left" size="1.2rem" color="#fff" @click="back" />
				<van-col span="24">
					二维码分享
				</van-col>
			</div>
			<div>
				<div style="width: 100%; height: 2rem;"></div>
				<img src="../../assets/qrcode.png" style="width: 100%; display: block;" @click="imgDown(url)" />
			</div>
		</div>
		<!-- 预览图 -->
		<van-image-preview v-model="show" :images="image"></van-image-preview>
	</div>
</template>

<script>
	import html2canvas from 'html2canvas'

	export default {
		data() {
			return {
				url: '',
				image: '',
				show: false,
			}
		},
		created() {
			this.toImage();
		},
		methods: {
			// 请求二维码图片
			toImage() {
				this.$axios.post(baseUrl + '/mobile/php_code/qrCode', {
					user_id: this.$route.query.user_id,
				}).then((res) => {
					if (res.data.code == 2) {
						this.url = res.data.data
					}
				})
			},
			// 图片预览
			imgDown(img) {
				console.log(img)
				if (typeof(img) == 'string') {
					this.show = true;
					this.image = [];
					this.image.push(img);
				} else {
					this.show = true;
					this.image = [];
					for (var i = 0; i < img.length; i++) {
						this.image.push(img[i]);
					}
				}
			},
		},

	}
</script>

<style>
	.van-image__error,
	.van-image__img,
	.van-image__loading {
		display: block;
		width: 80% !important;
		height: 80% !important;
		margin: auto;
		margin-top: 16%;
	}
</style>



// WEBPACK FOOTER //
// src/components/QRcode/QRcode.vue